<template>
    <div class="operator-wrapper" @click="operatorHandler">
        <div class="operator-button" v-for="item in items" :key="item.id" :attr-id="item.id">{{ item.label }}</div>
        <TwoLayerPopup class="operator-popup" :menus="classMenu" direct="bottom" :left="-180" :topOrBottom="1"
            :isShow="isShowPopup" @menuChange="menuChange" @menuHide="menuHide" />
    </div>
</template>

<script>
import TwoLayerPopup from "@/views/zhiji/bComponents/popupMenu/TwoLayerPopup";
import LockingQuestionModal from './LockingQuestionModal.vue';
import { recursionTrans } from "@/views/zhiji/js/common/util.js";
import i18n from "@/i18n";

export default {
    name: "OperatorColumn",
    props: ["data", "row"],
    components: {
        TwoLayerPopup,
        LockingQuestionModal
    },
    data() {
        return {
            isShowPopup: false,
            lockingData: {
                question: this.getQuestion(),
                questionId: this.row.rowId,
                reason: this.row.addData.lockReason,
                status: 0
            }
        };
    },
    computed: {
        labels() {
            return {
                transfer: this.$t("zhiji.common.transfer"),
                online: this.$t("zhiji.knowlege.online"),
                offline: this.$t("zhiji.knowlege.offline"),
                locking: this.$t("zhiji.knowlege.locking"),
                unlock: this.$t("zhiji.knowlege.unlock"),
                delete: this.$t("zhiji.common.delete"),
                setToFirst: this.$t("zhiji.knowlege.setToFirst"),
                setToReveal: this.$t("zhiji.knowlege.setToReveal")
            };
        },
        items() {
            return this.data.map(item => {
                return {
                    label: this.labels[item],
                    id: item
                };
            });
        },
        classMenu() {
            let treeData = this.getStorePorp("treeData").children || [];
            return recursionTrans(
                treeData,
                function(treesData) {
                    return {
                        value: treesData.id,
                        label: treesData.label
                    };
                },
                "children"
            );
        }
    },
    mounted() {
        window.document.addEventListener("click", this.windowClick);
    },
    destroyed() {
        window.document.removeEventListener("click", this.windowClick);
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionListPage[propName];
        },
        getQuestion() {
            return this.row.columns.find(e => e.colId === "standQuestion").data.value;
        },
        defaultLang() {
            const defaultLang = this.$store.state.zhiji.gameState.defaultLang;
            return defaultLang ? defaultLang : "en";
        },
        operatorHandler(event) {
            const target = event.target;
            const itemId = target.getAttribute("attr-id");

            itemId === "transfer" ? (this.isShowPopup = true) : itemId && this.tableClickAction(itemId);
        },
        // table按钮操作总入口
        tableClickAction(itemId) {
            const handlers = {
                delete: this.deleteAction,
                online: this.onlineAction,
                offline: this.offlineAction,
                unlock: this.unlockAction,
                locking: this.lockingAction,
                setToFirst: this.setToFirstAction,
                setToReveal: this.setToRevealAction,
            };

            handlers[itemId].call(null, itemId);
        },
        onlineAction(itemId) {
            if (this.row.addData.langType === this.defaultLang()) {
                const question = this.getQuestion();
                let tipStr = i18n.t("zhiji.knowlege.onlineRelatedTip");
                tipStr += `\n ${question}(${i18n.t("zhiji.knowlege.questionName")})， question_id=${this.row.rowId}`;
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: tipStr,
                        cancel: () => {},
                        confirm: () => {
                            this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                                status: itemId,
                                questionId: this.row.rowId,
                                question: question,
                            });
                        }
                    }
                });
            } else {
                this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                    status: itemId,
                    questionId: this.row.rowId,
                    question: this.getQuestion()
                });
            }
        },
        offlineAction(itemId) {
            if (this.row.addData.langType === this.defaultLang()) {
                // 默认语种，提示被影响的相关标问
                this.effectQuestion(i18n.t("zhiji.knowlege.offlineRelatedTip"), () => {
                    this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                        status: itemId,
                        questionId: this.row.rowId,
                        question: this.getQuestion()
                    });
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.knowlege.offlineQuesTip1"),
                        cancel: () => {},
                        confirm: () => {
                            this.$store.dispatch("zhiji/quesOnlineStatusChange", {
                                status: itemId,
                                questionId: this.row.rowId,
                                question: this.getQuestion()
                            });
                        }
                    }
                });
            }
        },
        unlockAction() {
            this.lockingData.status = 0;
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.knowlege.unlockTip"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch('zhiji/quesLockingStatusChange', this.lockingData);
                    }
                }
            });
        },
        lockingAction() {
            this.lockingData.status = 1;
            this.$store.dispatch('zhiji/showModal', {
                type: LockingQuestionModal,
                data: {
                    confirm: (inputVal) => {
                        this.lockingData.reason = inputVal;
                        this.$store.dispatch('zhiji/quesLockingStatusChange', this.lockingData);
                    },
                },
            });
        },
        deleteAction() {
            if (this.row.addData.langType === this.defaultLang()) {
                // 默认语种，提示被影响的相关标问
                this.effectQuestion(i18n.t("zhiji.knowlege.deleteRelatedTip"), () => {
                    this.$store.dispatch("zhiji/deleteQuestions", {
                        questionId: [this.row.rowId],
                        question: this.getQuestion()
                    });
                });
            } else {
                this.$store.dispatch("zhiji/showModal", {
                    type: "MessageModal",
                    data: {
                        type: "tip",
                        message: i18n.t("zhiji.knowlege.deleteQuesTip1"),
                        cancel: () => {},
                        confirm: () => {
                            this.$store.dispatch("zhiji/deleteQuestions", {
                                questionId: [this.row.rowId],
                                question: this.getQuestion()
                            });
                        }
                    }
                });
            }
        },
        setToFirstAction() {
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.knowlege.setFirstTip"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/setFirstQuestion", {
                            questionId: this.row.rowId
                        });
                    }
                }
            });
        },
        setToRevealAction() {
            // 设为兜底
            this.$store.dispatch("zhiji/showModal", {
                type: "MessageModal",
                data: {
                    type: "tip",
                    message: i18n.t("zhiji.knowlege.setRevealTip"),
                    cancel: () => {},
                    confirm: () => {
                        this.$store.dispatch("zhiji/setRevealQuestion", {
                            questionId: this.row.rowId
                        });
                    }
                }
            });
        },
        menuChange(option) {
            if (option.level == 1) {
                return; // 一级不可转移
            }
            const questionIds = this.row.rowId + "";
            this.isShowPopup = false;
            this.zhiji
                .requestByServiceName("judgeExistAloneNonDefault",{ questionIds })
                .then(res => {
                    if (res.exist) {
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "tip",
                                message: i18n.t("zhiji.knowlege.addTransferCurtailment"),
                                lineFeed: true,
                                confirm: () => {
                                    this.$store.dispatch("zhiji/transferQuestions", {
                                        classId: option.value,
                                        questionIds
                                    });
                                }
                            }
                        });
                    }else {
                        this.$store.dispatch("zhiji/transferQuestions", {
                            classId: option.value,
                            questionIds
                        });
                    }
                })
        },
        menuHide() {
            this.isShowPopup = false;
        },
        windowClick(event) {
            if (!this.$el.contains(event.target)) {
                this.isShowPopup = false;
            }
        },
        // 提示被影响的相关标问
        effectQuestion(tipTxt, callBack) {
            this.zhiji
                .requestByServiceName("getRelatedQuestion", {
                    questionId: this.row.rowId
                })
                .then(resp => {
                    let tipStr = tipTxt;
                    resp.map(item => {
                        tipStr += `\n ${item.question}(${i18n.t("zhiji.knowlege.questionName")})， question_id=${item.questionId}`;
                    });
                    resp.length &&
                        this.$store.dispatch("zhiji/showModal", {
                            type: "MessageModal",
                            data: {
                                type: "tip",
                                message: tipStr,
                                cancel: () => {},
                                confirm: () => {
                                    callBack();
                                }
                            }
                        });
                });
        }
    }
};
</script>

<style lang="less" scoped>
.operator-wrapper {
    // white-space: nowrap;
    .operator-button {
        display: inline-block;
        font-size: 12px;
        margin: 0 8px 2px 0;
        border: 1px solid #d8e4f0;
        padding: 0 8px;
        background: #fff;
        border-radius: 4px;
        height: 24px;
        line-height: 24px;

        &:hover {
            color: #2ec2ff;
            cursor: pointer;
        }
    }
}
</style>
